// colors
export const BRAND = '#6750A4';
export const SUCCESS = '#1de9b6';
export const WARNING = '#fc0';
export const ERROR = '#DC362E';
export const BACKGROUND_BRAND = '#f5f5fa';

export const CHAT_PAGE_SIZE = 30;
